module.exports = __webpack_public_path__ + "img/hehu.062f1ae6.png";